if(!customElements.get('move-to-top')){
    class MoveToTop extends HTMLElement {
        constructor(){
            super();
            this.onClick = this.scrollToTop.bind(this);
            this.onScroll = this.toggleVisibility.bind(this);
        }

        connectedCallback(){
            this.button = this.querySelector('.move-to-top__button');
            if(this.button){
                this.button.addEventListener('click', this.onClick);
            }

            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.toggleVisibility();
        }

        disconnectedCallback(){
            if(this.button){
                this.button.removeEventListener('click', this.onClick);
            }
            window.removeEventListener('scroll', this.onScroll);
        }

        scrollToTop(){
            // Keep keyboard navigation at the start of the content when this button hides.
            const target = document.getElementById('main');
            if(target) target.focus({ preventScroll: true });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        toggleVisibility(){
            const visible = window.scrollY > window.innerHeight * 0.5;
            this.setAttribute('data-visible', visible ? 'true' : 'false');
        }
    }

    customElements.define('move-to-top', MoveToTop);
}
